import { Component, OnInit } from '@angular/core';
import { ApiClient } from './common/api-client.service';

@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  ledger: any = {};
  recentTxns: Array<any> = [];

  constructor(
    private apiClient: ApiClient,
  ) {}

  ngOnInit() {
    this.apiClient.get<any>('/api/v1/ledger/details').toPromise().then(l => {
      this.ledger = l;
    });
    this.apiClient.get<any[]>('/api/v1/transactions', {limit: 10}).toPromise().then(txns => {
      this.recentTxns = txns;
    });
  }
}



// WEBPACK FOOTER //
// /srv/src/app/dashboard.component.ts